module.exports = __webpack_public_path__ + "static/media/ajax-load-big.1455ee75.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/ajax-load-big.gif
// module id = 963
// module chunks = 0